// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * Details for all kinds of technology mediated contact points for a person or organization, including telephone, email, etc.
 */
export type IContactPoint = fhir.IFhirElement & {
  /**
   * Time period when the contact point was/is in use.
   */
  period?: fhir.IPeriod|undefined;
  /**
   * Note that rank does not necessarily follow the order in which the contacts are represented in the instance.
   */
  rank?: number|undefined;
  _rank?: fhir.IFhirElement|undefined;
  /**
   * Telecommunications form for contact point - what communications system is required to make use of the contact.
   */
  system?: ContactPointSystemEnum|undefined;
  _system?: fhir.IFhirElement|undefined;
  /**
   * Applications can assume that a contact is current unless it explicitly says that it is temporary or old.
   */
  use?: ContactPointUseEnum|undefined;
  _use?: fhir.IFhirElement|undefined;
  /**
   * Additional text data such as phone extension numbers, or notes about use of the contact are sometimes included in the value.
   */
  value?: string|undefined;
  _value?: fhir.IFhirElement|undefined;
}
/**
 * Details for all kinds of technology mediated contact points for a person or organization, including telephone, email, etc.
 */
export class ContactPoint extends fhir.FhirElement implements fhir.IContactPoint {
  /**
   * Time period when the contact point was/is in use.
   */
  public period?: fhir.Period|undefined;
  /**
   * Note that rank does not necessarily follow the order in which the contacts are represented in the instance.
   */
  public rank?: number|undefined;
  public _rank?: fhir.FhirElement|undefined;
  /**
   * Telecommunications form for contact point - what communications system is required to make use of the contact.
   */
  public system?: ContactPointSystemEnum|undefined;
  public _system?: fhir.FhirElement|undefined;
  /**
   * Applications can assume that a contact is current unless it explicitly says that it is temporary or old.
   */
  public use?: ContactPointUseEnum|undefined;
  public _use?: fhir.FhirElement|undefined;
  /**
   * Additional text data such as phone extension numbers, or notes about use of the contact are sometimes included in the value.
   */
  public value?: string|undefined;
  public _value?: fhir.FhirElement|undefined;
  /**
   * Default constructor for ContactPoint - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IContactPoint> = {}) {
    super(source);
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (source["rank"]) { this.rank = source.rank; }
    if (source["_rank"]) { this._rank = new fhir.FhirElement(source._rank!); }
    if (source["system"]) { this.system = source.system; }
    if (source["_system"]) { this._system = new fhir.FhirElement(source._system!); }
    if (source["use"]) { this.use = source.use; }
    if (source["_use"]) { this._use = new fhir.FhirElement(source._use!); }
    if (source["value"]) { this.value = source.value; }
    if (source["_value"]) { this._value = new fhir.FhirElement(source._value!); }
  }
  /**
   * Check if the current ContactPoint contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a ContactPoint from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IContactPoint):ContactPoint {
    var dest:ContactPoint = new ContactPoint(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `ContactPoint is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Code Values for the ContactPoint.system field
 */
export enum ContactPointSystemEnum {
  PHONE = "phone",
  FAX = "fax",
  EMAIL = "email",
  PAGER = "pager",
  URL = "url",
  SMS = "sms",
  OTHER = "other",
}
/**
 * Code Values for the ContactPoint.use field
 */
export enum ContactPointUseEnum {
  HOME = "home",
  WORK = "work",
  TEMP = "temp",
  OLD = "old",
  MOBILE = "mobile",
}
